import { render, staticRenderFns } from "./block3.vue?vue&type=template&id=7e91a79b&scoped=true"
import script from "./block3.vue?vue&type=script&lang=js"
export * from "./block3.vue?vue&type=script&lang=js"
import style0 from "./block3.vue?vue&type=style&index=0&id=7e91a79b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e91a79b",
  null
  
)

export default component.exports